import { render, staticRenderFns } from "./MachZehnderViz.vue?vue&type=template&id=52d0671a&scoped=true"
import script from "./MachZehnderViz.vue?vue&type=script&lang=js"
export * from "./MachZehnderViz.vue?vue&type=script&lang=js"
import style0 from "./MachZehnderViz.vue?vue&type=style&index=0&id=52d0671a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52d0671a",
  null
  
)

export default component.exports